import * as React from 'react';
import { TextAvatar, TextAvatarSize } from './TextAvatar';
import { Flex } from '../compositeComponents/FlexHelpers';

export type UserAvatarProps = {
    user:{
        displayName:string,
        initials:string
    },
    identifier?:string,
    backgroundColorOverride?: string,
    size?: TextAvatarSize,
    selected?:boolean,
    extraTooltipRows?:string[],
    noToolTip?:boolean,
    onClick?: (identifier:string) => void
};

export function UserAvatar (props: UserAvatarProps): JSX.Element
{
    return (
        <TextAvatar size={props.size || '32px'}
            text={props.user.initials}
            identifier={props.identifier}
            selected={props.selected}
            onClick={props.onClick}
            colorGenerationString={props.backgroundColorOverride ? undefined : props.user.initials}
            backgroundColor={props.backgroundColorOverride}
            toolTip={
                props.noToolTip
                    ?   undefined
                    :   <Flex flexDirection="column" gap={4} alignItems='center'>
                            <div style={{fontSize:'16px'}}>{props.user.displayName}</div>
                            {props.extraTooltipRows && props.extraTooltipRows.map((row, index) => (
                                <div key={index} style={{fontSize:'12px'}}>{row}</div>
                            ))}
                        </Flex>
            } 
        />
    );
}
